import { render, staticRenderFns } from "./WizardWrap.vue?vue&type=template&id=674a962a&"
import script from "./WizardWrap.vue?vue&type=script&lang=js&"
export * from "./WizardWrap.vue?vue&type=script&lang=js&"
import style0 from "./WizardWrap.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports